import v from "./extends.mjs";
import z from "./objectWithoutPropertiesLoose.mjs";
import * as p from "react";
import e from "./index180.mjs";
import { clsx as Z } from "./clsx.mjs";
import le from "./styled.mjs";
import Oe from "./useThemeProps.mjs";
import { getPopoverUtilityClass as Re } from "./popoverClasses.mjs";
import { jsx as D } from "react/jsx-runtime";
import xe from "./Modal.mjs";
import we from "./Paper.mjs";
import Ne from "./useForkRef.mjs";
import ee from "./ownerDocument.mjs";
import oe from "./ownerWindow.mjs";
import Se from "./debounce.mjs";
import { isHostComponent as Ce } from "./isHostComponent.mjs";
import _e from "./refType.mjs";
import Me from "./chainPropTypes.mjs";
import te from "./HTMLElementType.mjs";
import je from "./integerPropType.mjs";
import ze from "./elementTypeAcceptingRef.mjs";
import De from "./composeClasses.mjs";
import ke from "./Grow.mjs";
import { useSlotProps as ne } from "./useSlotProps2.mjs";
const Le = ["onEntering"], $e = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], Ie = ["slotProps"];
function re(t, o) {
  let i = 0;
  return typeof o == "number" ? i = o : o === "center" ? i = t.height / 2 : o === "bottom" && (i = t.height), i;
}
function ie(t, o) {
  let i = 0;
  return typeof o == "number" ? i = o : o === "center" ? i = t.width / 2 : o === "right" && (i = t.width), i;
}
function se(t) {
  return [t.horizontal, t.vertical].map((o) => typeof o == "number" ? `${o}px` : o).join(" ");
}
function x(t) {
  return typeof t == "function" ? t() : t;
}
const Ve = (t) => {
  const {
    classes: o
  } = t;
  return De({
    root: ["root"],
    paper: ["paper"]
  }, Re, o);
}, We = le(xe, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})({}), qe = le(we, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (t, o) => o.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), ae = /* @__PURE__ */ p.forwardRef(function(o, i) {
  var k, L, $;
  const E = Oe({
    props: o,
    name: "MuiPopover"
  }), {
    action: pe,
    anchorEl: c,
    anchorOrigin: g = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: w,
    anchorReference: b = "anchorEl",
    children: ce,
    className: fe,
    container: ue,
    elevation: I = 8,
    marginThreshold: l = 16,
    open: u,
    PaperProps: he = {},
    slots: O,
    slotProps: R,
    transformOrigin: T = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: N = ke,
    transitionDuration: S = "auto",
    TransitionProps: {
      onEntering: V
    } = {},
    disableScrollLock: C = !1
  } = E, W = z(E.TransitionProps, Le), me = z(E, $e), h = (k = R?.paper) != null ? k : he, _ = p.useRef(), de = Ne(_, h.ref), M = v({}, E, {
    anchorOrigin: g,
    anchorReference: b,
    elevation: I,
    marginThreshold: l,
    externalPaperSlotProps: h,
    transformOrigin: T,
    TransitionComponent: N,
    transitionDuration: S,
    TransitionProps: W
  }), q = Ve(M), H = p.useCallback(() => {
    if (b === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (w || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), w;
    const n = x(c), r = n && n.nodeType === 1 ? n : ee(_.current).body, s = r.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const m = r.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && m.top === 0 && m.left === 0 && m.right === 0 && m.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: s.top + re(s, g.vertical),
      left: s.left + ie(s, g.horizontal)
    };
  }, [c, g.horizontal, g.vertical, w, b]), U = p.useCallback((n) => ({
    vertical: re(n, T.vertical),
    horizontal: ie(n, T.horizontal)
  }), [T.horizontal, T.vertical]), A = p.useCallback((n) => {
    const r = {
      width: n.offsetWidth,
      height: n.offsetHeight
    }, s = U(r);
    if (b === "none")
      return {
        top: null,
        left: null,
        transformOrigin: se(s)
      };
    const m = H();
    let d = m.top - s.vertical, P = m.left - s.horizontal;
    const X = d + r.height, J = P + r.width, K = oe(x(c)), y = K.innerHeight - l, Q = K.innerWidth - l;
    if (l !== null && d < l) {
      const a = d - l;
      d -= a, s.vertical += a;
    } else if (l !== null && X > y) {
      const a = X - y;
      d -= a, s.vertical += a;
    }
    if (process.env.NODE_ENV !== "production" && r.height > y && r.height && y && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${r.height - y}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), l !== null && P < l) {
      const a = P - l;
      P -= a, s.horizontal += a;
    } else if (J > Q) {
      const a = J - Q;
      P -= a, s.horizontal += a;
    }
    return {
      top: `${Math.round(d)}px`,
      left: `${Math.round(P)}px`,
      transformOrigin: se(s)
    };
  }, [c, b, H, U, l]), [Pe, B] = p.useState(u), f = p.useCallback(() => {
    const n = _.current;
    if (!n)
      return;
    const r = A(n);
    r.top !== null && (n.style.top = r.top), r.left !== null && (n.style.left = r.left), n.style.transformOrigin = r.transformOrigin, B(!0);
  }, [A]);
  p.useEffect(() => (C && window.addEventListener("scroll", f), () => window.removeEventListener("scroll", f)), [c, C, f]);
  const ve = (n, r) => {
    V && V(n, r), f();
  }, ge = () => {
    B(!1);
  };
  p.useEffect(() => {
    u && f();
  }), p.useImperativeHandle(pe, () => u ? {
    updatePosition: () => {
      f();
    }
  } : null, [u, f]), p.useEffect(() => {
    if (!u)
      return;
    const n = Se(() => {
      f();
    }), r = oe(c);
    return r.addEventListener("resize", n), () => {
      n.clear(), r.removeEventListener("resize", n);
    };
  }, [c, u, f]);
  let F = S;
  S === "auto" && !N.muiSupportAuto && (F = void 0);
  const be = ue || (c ? ee(x(c)).body : void 0), j = (L = O?.root) != null ? L : We, Y = ($ = O?.paper) != null ? $ : qe, Te = ne({
    elementType: Y,
    externalSlotProps: v({}, h, {
      style: Pe ? h.style : v({}, h.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: I,
      ref: de
    },
    ownerState: M,
    className: Z(q.paper, h?.className)
  }), G = ne({
    elementType: j,
    externalSlotProps: R?.root || {},
    externalForwardedProps: me,
    additionalProps: {
      ref: i,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: be,
      open: u
    },
    ownerState: M,
    className: Z(q.root, fe)
  }), {
    slotProps: ye
  } = G, Ee = z(G, Ie);
  return /* @__PURE__ */ D(j, v({}, Ee, !Ce(j) && {
    slotProps: ye,
    disableScrollLock: C
  }, {
    children: /* @__PURE__ */ D(N, v({
      appear: !0,
      in: u,
      onEntering: ve,
      onExited: ge,
      timeout: F
    }, W, {
      children: /* @__PURE__ */ D(Y, v({}, Te, {
        children: ce
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (ae.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: _e,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: Me(e.oneOfType([te, e.func]), (t) => {
    if (t.open && (!t.anchorReference || t.anchorReference === "anchorEl")) {
      const o = x(t.anchorEl);
      if (o && o.nodeType === 1) {
        const i = o.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && i.top === 0 && i.left === 0 && i.right === 0 && i.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${o}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: e.shape({
    horizontal: e.oneOfType([e.oneOf(["center", "left", "right"]), e.number]).isRequired,
    vertical: e.oneOfType([e.oneOf(["bottom", "center", "top"]), e.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: e.shape({
    left: e.number.isRequired,
    top: e.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: e.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: e.oneOfType([te, e.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: e.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: je,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: e.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: e.func,
  /**
   * If `true`, the component is shown.
   */
  open: e.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: e.shape({
    component: ze
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: e.shape({
    paper: e.oneOfType([e.func, e.object]),
    root: e.oneOfType([e.func, e.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: e.shape({
    paper: e.elementType,
    root: e.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: e.shape({
    horizontal: e.oneOfType([e.oneOf(["center", "left", "right"]), e.number]).isRequired,
    vertical: e.oneOfType([e.oneOf(["bottom", "center", "top"]), e.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: e.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: e.oneOfType([e.oneOf(["auto"]), e.number, e.shape({
    appear: e.number,
    enter: e.number,
    exit: e.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: e.object
});
const fo = ae;
export {
  qe as PopoverPaper,
  We as PopoverRoot,
  fo as default,
  ie as getOffsetLeft,
  re as getOffsetTop
};
//# sourceMappingURL=Popover.mjs.map
